@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.results {
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  gap: 16px;
  height: calc(100% - 200px);
  overflow: auto;

  [data-autopilot-system-redesign='on'] & {
    height: calc(100% - 106px);
    padding-top: 8px;
  }

  .resultsList {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
}

.spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: conic-gradient(var(--light-100), var(--dark-80));
  border-radius: 100%;
  animation: rotate infinite 1s linear;

  &::after {
    display: block;
    content: '';
    width: 24px;
    height: 24px;
    background: var(--light-100);
    border-radius: 100%;
  }
}

.placeholder {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
  text-align: center;
  padding-bottom: 80px;

  @include for-phone-only {
    padding-bottom: 0;
  }
}

.placeholder.success {
  gap: 8px;

  .successTitle {
    line-height: 112%;
  }
}

.wordCount {
  color: var(--dark-80);
}

.plagiarismResult {
  display: flex;
  flex-direction: column;
  gap: 4px;

  [data-autopilot-system-redesign='on'] & {
    cursor: pointer;
  }

  &:last-child {
    border-bottom: none;
  }

  .title {
    color: var(--dark-80);
  }

  .url {
    color: var(--selected-fill);
  }

  .content {
    color: var(--dark-80);
  }
}

.loadingText {
  text-align: center;
  color: var(--dark-80);
}

.svgWrapper {
  background: var(--green-50);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;

  color: var(--light-100);
  svg {
    width: 24;
    height: 24;
  }

  &.failure {
    background: var(--red-50);
  }
}

.plagiarismDetectionButton {
  display: flex;
  align-items: center;
  gap: 5px;
}
